import InvitationService from "@/services/api/invitation";
import type { Invitation, GetInvitationsParams, GetInvitationsResponse } from "@/types/invitation";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface InvitationState {
  invitations: Invitation[];
  totalInvitations: number;
  isFetching: boolean;
}

const initialState: InvitationState = {
  invitations: [],
  totalInvitations: 0,
  isFetching: false,
};

// Async thunk to fetch invitations
export const getInvitations = createAsyncThunk<
  GetInvitationsResponse,
  GetInvitationsParams,
  { rejectValue: string }
>("invitation/getInvitations", async (params, { rejectWithValue }) => {
  try {
    const data = await InvitationService.fetchInvitations(params);
    // Support backend response returning { data: { count, rows } } or { count, rows } directly
    const result = data?.data ?? data;
    console.log(result);
    
    return result ?? { rows: [], count: 0 };
  } catch (err: any) {
    return rejectWithValue(err.message ?? "Failed to fetch invitations");
  }
});

const invitationSlice = createSlice({
  name: "invitation",
  initialState,
  reducers: {
    clear: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInvitations.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(
        getInvitations.fulfilled,
        (state, action: PayloadAction<GetInvitationsResponse>) => {
          state.isFetching = false;
          console.log(action.payload);
          
          state.invitations = action.payload?.results || action.payload?.rows || [];
          state.totalInvitations = action.payload?.totalRecord || action.payload?.count || 0;
        }
      )
      .addCase(getInvitations.rejected, (state, action) => {
        state.isFetching = false;
        console.error("Failed to fetch invitations:", action.payload);
      });
  },
});

export default invitationSlice.reducer;
export const { clear } = invitationSlice.actions;
export type { InvitationState };
